export default __webpack_public_path__ + "static/Amit Cherniak-ad6e3527b4233271bc42fade6b540ef0.png";